module.exports = __webpack_public_path__ + "static/60-6ecacc825a9af24600184a3b83fc7813.jpg";